import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { glossary } from '@sorare/core/src/lib/glossary';

import type { DropChallengeButton_taskInterface } from './__generated__/index.graphql';

type Props = {
  task: DropChallengeButton_taskInterface;
  onClick?: () => void;
};
export const DropChallengeButton = ({ task, onClick }: Props) => {
  const track = useEvents();

  return (
    <Button
      size="compact"
      color="secondary"
      onClick={() => {
        track('Click Mission Button', {
          slug: task.taskConfigSlug,
          onboarding: false,
        });
        onClick?.();
      }}
    >
      <FormattedMessage {...glossary.play} />
    </Button>
  );
};

DropChallengeButton.fragments = {
  taskInterface: gql`
    fragment DropChallengeButton_taskInterface on TaskInterface {
      id
      taskConfigSlug
    }
  ` as TypedDocumentNode<DropChallengeButton_taskInterface>,
};
